export default class y {
  constructor() {}
  Ss(a) {}
  changeUser(a = !1) {}
  clearData(a = !1) {}
}
